
import { ProductCatalogDto, CreateProductCatalogDto, UpdateProductCatalogDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { productCatalogService, ProductCatalogsFilters } from '@services/ProductCatalogService'

const { reducer, actions, thunks } = baseCrudReducer<
  ProductCatalogDto,
  CreateProductCatalogDto,
  UpdateProductCatalogDto,
  ProductCatalogsFilters
>('productCatalog', productCatalogService)

export default reducer

export const { setFilters: setProductCatalogFilters } = actions

export const {
  getAll: getProductCatalogs,
  create: createProductCatalog,
  update: updateProductCatalog,
  remove: removeProductCatalog,
} = thunks
